<template>
    <ul class="flex gap-12 tablet:gap-4 items-center  mobile:hidden">
        <li v-for="(name, value, index) in CheckoutPage" class="flex gap-2 items-center">
            <span class="size-8 rounded-lg bg-grey-100 flex items-center justify-center text-sm font-medium text-grey-700" 
                  :class="{'text-white bg-primary-400': index == activePageIndex}">
                <template v-if="(index) < activePageIndex">
                    <i class="fas fa-check text-primary-400"></i>
                </template>
                <template v-else>
                    {{index + 1}}
                </template>
            </span>
            <span class="font-medium text-grey-600 text-sm tablet:text-xs" :class="{'!text-black': index == activePageIndex}">
                {{translate(name)}}
            </span>
        </li>
    </ul>
</template>

<script lang="ts">
import {defineComponent} from 'vue';
import {CheckoutPage, Package} from "../../types";
import QueryString from "../../../../lib/QueryString";
import {useStore} from "../../store";

export default defineComponent({
    name: "wizard",
    props:{
        currentPage: String as () => CheckoutPage
    },
    data() {
        const checkoutStore = useStore();
        return {
            checkoutStore: checkoutStore,
            CheckoutPage
        }
    },
    computed:{
        activePageIndex() : number {
            return Object.values(CheckoutPage).indexOf(this.currentPage)
        }
    }, mounted() {
        if(QueryString.getUrlParameter("renew") === "true"){
            QueryString.deleteUrlParameter("renew");
            if(this.checkoutStore.canGoToNextPage) {
                this.checkoutStore.setRenewOrderStarted();
                this.checkoutStore.nextPage();
            }
        }
       
    }
})
</script>